module.exports = __webpack_public_path__ + "static/media/Balushai.64a1ccd5.png";